import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconSortChevron = ({ className = '', color = '#aeaeae', height = 11, title, width = 11 }: Icon) => (
    <AccessibleSVG
        className={`bdl-icon-sort-chevron ${className}`}
        height={height}
        title={title}
        viewBox="0 0 9.8 9.7"
        width={width}
    >
        <path
            className="fill-color"
            d="M4.9 6.7c-.1 0-.3-.1-.4-.2L2 4c-.3-.2-.3-.6 0-.8s.6-.2.8 0l2.1 2.1L7 3.2c.2-.2.6-.2.8 0s.2.6 0 .8L5.3 6.5c-.1.1-.3.2-.4.2z"
            fill={color}
        />
    </AccessibleSVG>
);

export default IconSortChevron;
